const mobileListItems = document.querySelectorAll('.MobileMenu li.menu-item-has-children');
const mobileLinks = document.querySelectorAll('.MobileMenu li:not(.menu-item-has-children) a ');
const goBackButtons = document.querySelectorAll('.Navigation__subMenu__go-back');

const handleSubMenu = (ev) => {
    ev.preventDefault();
    const list = ev.currentTarget.querySelector('ul');
    list.classList.add('open');
};

const handleGoBack = (ev) => {
    ev.stopPropagation();
    const parentContainerElement = ev.currentTarget.parentElement;
    parentContainerElement.classList.remove('open');
};

const handleLinks = (ev) => {
    ev.stopPropagation();
};

mobileListItems?.forEach((item) => item.addEventListener('click', handleSubMenu));

goBackButtons?.forEach((item) => item.addEventListener('click', handleGoBack));

mobileLinks?.forEach((item) => item.addEventListener('click', handleLinks));
